import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledLoanButton,
  StyledInput,
  StyledLoanInputWrapper,
} from './styled';

const toNumber = (value, fallback = 0) => {
  const parsed = parseInt(value, 10);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const NumberRangeSelect = ({
  callback = () => { },
  className = '',
  stepAmount = 100000,
  prefix,
  placeholder = "$0",
  suffix = "",
  maxValue = null,
  minValue = 0,
  thousandSeparator = true,
  value,
}) => {
  const isControlled = value !== undefined && value !== null;
  const [internalAmount, changeInternalAmount] = React.useState(
    toNumber(isControlled ? value : minValue, toNumber(minValue))
  );
  const amountNumber = isControlled ? toNumber(value, toNumber(minValue)) : internalAmount;

  const emit = (next) => {
    if (!isControlled) {
      changeInternalAmount(next);
    }
    callback(next);
  };

  const decrementAmount = (amount) => {
    const next = Math.max(toNumber(minValue), toNumber(amount) - stepAmount);
    emit(next);
  };
  const incrementAmount = (amount) => {
    const raw = toNumber(amount) + stepAmount;
    const next = maxValue != null ? Math.min(toNumber(maxValue), raw) : raw;
    emit(next);
  };

  return (
    <StyledLoanInputWrapper className={className}>
      <StyledLoanButton
        primary
        disabled={amountNumber <= minValue || !amountNumber}
        onClick={() => {
          decrementAmount(amountNumber);
        }}
        type="button"
      >
        -
      </StyledLoanButton>
      <StyledInput
        isNumericString
        value={amountNumber}
        allowNegative={false}
        onValueChange={(val) => {
          if (val.value === '' || val.value == null) return;
          const next = toNumber(val.value, amountNumber);
          if (next === amountNumber) return;
          emit(next);
        }}
        thousandSeparator={thousandSeparator}
        prefix={prefix}
        suffix={suffix}
        placeholder={placeholder}
      />
      <StyledLoanButton
        disabled={maxValue ? amountNumber >= maxValue : false}
        primary
        onClick={() => {
          incrementAmount(amountNumber);
        }}
        type="button"
      >
        +
      </StyledLoanButton>
    </StyledLoanInputWrapper>
  );
};
NumberRangeSelect.propTypes = {
  stepAmount: PropTypes.number,
  callback: PropTypes.func,
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
NumberRangeSelect.defaultProps = {
  stepAmount: 100000,
  callback: () => { },
  className: '',
};
export default NumberRangeSelect;
